export enum ChangeSetCardStatusActionTypes {
  CHANGING_STATUS = 'set-cards/CHANGING_STATUS',
  STATUS_CHANGED = 'set-cards/STATUS_CHANGED',
}
